import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/membershipBreakdownSaga";

const IncludeZeroSales = () => {
  const dispatch = useDispatch();
  const selectedIncludeZeroSales = useSelector(
    (state) => state.membershipBreakdown.selectedFilters.includeZeroSales
  );
  const includeZeroSalesOptions = useSelector(
    (state) => state.membershipBreakdown.filters.includeZeroSales
  );

  return (
    <MultiSelectDropdown
      options={includeZeroSalesOptions}
      selectedFilters={selectedIncludeZeroSales}
      includeFilter={false}
      numberDisplayed={1}
      onSelectChange={(data) => dispatch(actionCreators.updateIncludeZeroSales(data))}
    />
  );
};

export default IncludeZeroSales;
